import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-arrow-up.tsx
/**
* icon.24.arrow.up
*
* Keywords: upward, vertical, direction, navigation, movement, ascend, pointing, north
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTIgMTZhLjUuNSAwIDAgMS0uNS0uNVY4LjcwN2wtMy4xNDYgMy4xNDdhLjUuNSAwIDAgMS0uNzA4LS43MDhsNC00YS41LjUgMCAwIDEgLjcwOCAwbDQgNGEuNS41IDAgMCAxLS43MDguNzA4TDEyLjUgOC43MDdWMTUuNWEuNS41IDAgMCAxLS41LjUiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-2839
*/
const Icon24ArrowUp = memo(function Icon24ArrowUp(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M12 16a.5.5 0 0 1-.5-.5V8.707l-3.146 3.147a.5.5 0 0 1-.708-.708l4-4a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1-.708.708L12.5 8.707V15.5a.5.5 0 0 1-.5.5",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24ArrowUp };

//# sourceMappingURL=icon-24-arrow-up.js.map